import { routes } from "routing";
import { lazyView, type RouteRender } from "routing/tree";

/** The home tab root. Rendered under HomeRoutes in routes.tsx, same as the team root. */
export const homeRoutes: RouteRender[] = [
  lazyView(routes.home, () => import("./home").then((m) => ({ default: m.HomePage })), "Home"),
];
